/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_State_In_ProgressInputs */



/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Tournaments_Lib_State_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_state_in_progress = /** @type {((inputs?: Tournaments_Lib_State_In_ProgressInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_State_In_ProgressInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Läuft")
	if (locale === "fr") return /** @type {LocalizedString} */ ("En cours")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("进行中")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("進行中")
	if (locale === "ko") return /** @type {LocalizedString} */ ("진행 중")
	return /** @type {LocalizedString} */ ("In progress")
});